



















































import {Component, Vue} from "vue-property-decorator"
import store from "./../store"
import router from "@/router"
import {cacheSrv} from "./../services/cache"
import {systemSrv} from "./../services/system"
import axios from "axios"

@Component({
  components: {},
})
export default class Invitation extends Vue {
  params
  userApiUrl
  CACHE_KEY_TOKEN

  username_pattern = /^[a-zA-Z0-9._-]*$/
  password_pattern = /^[a-zA-Z0-9!@#%\^\)\(+=._-]{6,}$/
      
  rules: any = {
    required: (value) => !!value || "Required.",
    username: (value) => {
      return this.username_pattern.test(value) || "Invalid username. Only Letters, Numbers, dot and underscore allowed. No spaces"
    },
    password: (value) => {
      return this.password_pattern.test(value) || "Min 6 characters. Please only use Letters, Numbers, Special characters and underscore. No spaces please"
    },
  }

  data: any = {
    step: "invitation-form",
    user: {
      invitationKey: "",
      password: "",
      confirmPassword: "",
    },
  }
  submitted = false
  processing = false
  errorMessage = ""
  error = {
    msg: "",
  }
  constructor() {
    super()
  }
  validate(passwordField) {
    console.log("validating passwordField", passwordField)
  }
  created() {
    this.params = this.$route.params
    this.userApiUrl = this.$store.getters.config.userApiUrl
    this.CACHE_KEY_TOKEN = this.$store.getters.tokenKeys.CACHE_KEY_TOKEN
    this.init()
  }
  mounted() {
    this.userApiUrl = this.$store.getters.config.userApiUrl
    this.CACHE_KEY_TOKEN = this.$store.getters.tokenKeys.CACHE_KEY_TOKEN
  }

  async init() {
    this.errorMessage = ""
    this.processing = true
    let result
    if (!this.params.invitationKey) {
      this.errorMessage = "Missing invitation key. Your invitation link is not valid. Please request new invitation link from Sunway Malls"
      this.processing = false
      return
    }

    try {
      result = await axios.post(`${this.userApiUrl}/tenant/api/jwt/invitation`, {invitationKey: this.params.invitationKey})
      console.log("result", result.data)
    } catch (e) {
      this.processing = false
      this.errorMessage = "Error procesing your request. Please check your internet connection and try again"
      return
    }
    this.processing = false
    if (result.data) {
      let data = result.data
      console.log("data", data)
      if (data.error) {
        console.log("Error in loading invite")
        this.data.step = "invite-error"
        this.errorMessage = data.message
        return
      }
      if (data.invitationKey == this.params.invitationKey) {
        data.username = ""
        this.data.user = data
      } else {
        console.log("Problem with invitation key")
        this.data.step = "invite-expired"
      }
    }
  }
  async confirmInvitation() {
    this.errorMessage = ""
    this.processing = true
    let result
    if (!this.data.user.username || !this.data.user.password || !this.data.user.confirmPassword || this.data.user.password != this.data.user.confirmPassword) {
      this.errorMessage = "Please provide your username, password and confirm password"
      this.processing = false
      return
    }

    let valid = this.validateInput()
    if(!valid){
      this.errorMessage = "Please provide valid username, alphanumerics without spaces, and valid password."
      this.processing = false
      return
    }

    try {
      result = await axios.post(`${this.userApiUrl}/tenant/api/jwt/confirm-invitation`, this.data.user)
      console.log("result", result.data)
    } catch (e) {
      this.processing = false
      this.errorMessage = "Error procesing your request. Please check your internet connection and try again"
      return
    }
    this.processing = false
    if (result.data) {
      let data = result.data
      console.log("data", data)
      if (data.error) {
        console.log("Error in validating number")
        this.errorMessage = data.message
        return
      }
      this.data.step = "confirmation"
    }
  }
  validateInput(){
    let username = this.data.user.username
    let password = this.data.user.password
    let valid = true
    if (!this.username_pattern.test(username)) {
      valid = false
    }
    if (!this.password_pattern.test(password)) {
      valid = false
    }
    return valid
  }
  goLogin() {
    router.push({name: "login"})
  }
}
